"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppleStatusResponseSchema = exports.ChannelAppleStatusSchema = exports.RegionAppleStatusSchema = exports.RegionAppleAdGroupStatusSchema = exports.RegionAppleCampaignStatusSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.RegionAppleCampaignStatusSchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.AppleProxyRefSchema,
    orgRef: ruby_1.AppleProxyOrgRefSchema,
    data: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCampaignSchema),
});
exports.RegionAppleAdGroupStatusSchema = (0, core_1.StrictObject)({
    adGroupRef: ruby_1.AppleProxyRefSchema,
    data: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyAdGroupSchema),
});
exports.RegionAppleStatusSchema = (0, core_1.StrictObject)({
    country: core_1.CountrySchema,
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    appleCampaign: typebox_1.Type.Optional(exports.RegionAppleCampaignStatusSchema),
    appleAdGroups: typebox_1.Type.Optional(typebox_1.Type.Array(exports.RegionAppleAdGroupStatusSchema)),
});
exports.ChannelAppleStatusSchema = (0, core_1.StrictObject)({
    structure: ruby_1.ChannelStructureSchema,
    orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyOrgRefSchema),
    applicationRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    regions: typebox_1.Type.Array(exports.RegionAppleStatusSchema),
    applePaymentModel: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyPaymentModelSchema),
    productPageRef: typebox_1.Type.Optional(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
    status: ruby_1.AppleChannelStatusSchema,
});
exports.GetAppleStatusResponseSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    channelType: ruby_1.ChannelTypeSchema,
    channels: typebox_1.Type.Array(exports.ChannelAppleStatusSchema),
});
